import React, { useEffect } from 'react';
import Confetti from 'react-confetti';

const SuccessModal = ({ isOpen, onClose, message, drinkName }) => {
  useEffect(() => {
    if (isOpen) {
      // Modal nach 2.5 Sekunden automatisch schließen
      const timer = setTimeout(() => {
        onClose();
      }, 2500);
      
      return () => clearTimeout(timer);
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <>
      <Confetti
        width={window.innerWidth}
        height={window.innerHeight}
        recycle={false}
        numberOfPieces={200}
        gravity={0.3}
      />
      
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content" onClick={e => e.stopPropagation()}>
          <div className="text-center">
            <div className="text-6xl mb-4">🎉</div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">
              {message || 'Getränk erfolgreich gebucht!'}
            </h3>
            {drinkName && (
              <p className="text-gray-600 mb-4">
                {drinkName} wurde zu deinem Konto hinzugefügt
              </p>
            )}
            <div className="text-4xl mb-4">🍺</div>
            <button
              onClick={onClose}
              className="btn-primary w-full"
            >
              Prost! 🍻
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SuccessModal; 